import { render, staticRenderFns } from "./OrderListForm.vue?vue&type=template&id=842834b6&"
import script from "./OrderListForm.vue?vue&type=script&lang=js&"
export * from "./OrderListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports